/**************************************************
 * Nombre:       BarraInferior
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, TablePagination, useMediaQuery} from "@mui/material";
import {Download} from "@mui/icons-material";
import {theme} from "../../../../Tema";

const BarraInferior = ({
                           numeroFilas,
                           filasPagina,
                           page,
                           cambiarPagina,
                           filasPaginaCambia,
                           ComponenteInferior
                       }) => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))

    return (
        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{alignItems: 'center'}} >

            <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{mt: 2}}>
                <ComponenteInferior/>

            </Grid>

            <Grid container size={{xs: 12, sm: 4, md: 4}}
                   sx={{justifyContent: sCell ? 'center' : 'flex-end',}}>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={numeroFilas}
                    rowsPerPage={filasPagina}
                    page={page}
                    onPageChange={cambiarPagina}
                    onRowsPerPageChange={filasPaginaCambia}
                    labelRowsPerPage={'Filas'}
                    sx={{overflowX: 'hidden'}}
                />
            </Grid>

        </Grid>
    )

}
export default BarraInferior